export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_SUCCEEDED = "GET_PRODUCT_SUCCEEDED";
export const GET_PRODUCT_FAILED = "GET_PRODUCT_FAILED";
